import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArticlePlaceholder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 75,
	height: 72,
	viewBox: "0 0 75 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .245361,
		width: 74.2086,
		height: 72,
		rx: 6,
		fill: "#DFF1FA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M43.8899 29.9077C44.793 29.9077 45.5251 30.5139 45.5251 31.2616V40.7385C45.5251 41.4862 44.793 42.0923 43.8899 42.0923H30.8091C29.9061 42.0923 29.174 41.4862 29.174 40.7385V31.2616C29.174 30.5139 29.9061 29.9077 30.8091 29.9077H43.8899ZM43.8899 31.2616H30.8091V38.0988L34.8926 34.7177C35.2917 34.3873 35.9388 34.3873 36.3379 34.7177L39.6619 37.47L40.6736 36.6324C41.0727 36.3019 41.7198 36.3019 42.1188 36.6324L43.8899 38.0988V31.2616ZM40.211 32.6154C40.8882 32.6154 41.4373 33.07 41.4373 33.6308C41.4373 34.1916 40.8882 34.6462 40.211 34.6462C39.5337 34.6462 38.9846 34.1916 38.9846 33.6308C38.9846 33.07 39.5337 32.6154 40.211 32.6154Z",
		fill: "#09244B",
		fillOpacity: .25
	})]
});
export default SvgArticlePlaceholder;
